import generatePicker, { PickerProps } from 'antd/es/date-picker/generatePicker';
import type { Moment } from 'moment-timezone';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const DatePicker = generatePicker<Moment>(momentGenerateConfig);
export type DatePickerProps = PickerProps<Moment>;

export default DatePicker;
